<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div v-if="!races">
          loading races...
        </div>
        <div v-if="races">
          <div
            v-for="race in races"
            :key="race.ve"
            class="race"
          >
            {{ race.ve }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Race',
  data() {
    return {
      races: null
    };
  },
  created() {
    this.$store.commit('changeInfoBarMessage', 'Welcome to Races page!');

    this.getVenues();
  },
  methods: {
    getVenues() {
      axios.get(this.$store.state.screensApiUrl + '/venue', {
        headers: { 'Authorization': 'Bearer KjGR7KPJDYCcdH5Jdxhet5Mw' }
      })
        .then((response) => {
          this.races = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

};
</script>



// WEBPACK FOOTER //
// Race.vue?07d66159